/* eslint-disable multiline-ternary */
import React, { useState } from 'react'
import Intro from './Intro'
import exercises from '../exercises.json'

const $ = window.jQuery || window.$

const cols = [
  {
    id: 1,
    color: 'yellow-300',
    desc: 'warmup',
    title: 'Warm-Up',
    type: 'warm',
    cards: exercises.warm
  },
  {
    id: 2,
    color: 'red-600',
    desc: 'move',
    title: 'Move',
    type: 'move',
    cards: exercises.move
  },
  {
    id: 3,
    color: 'blue-300',
    desc: 'cooldown',
    title: 'Cool Down',
    type: 'cool',
    cards: exercises.cool
  }
]

export default function WideApp () {
  const [step, setStep] = useState(1)

  const navigateNext = () => {
    const nextStep = step >= 4 ? 1 : step + 1

    setStep(nextStep)

    if (nextStep === 2) {
      $(function () {
        window.sanfordFitBoost = new window.SanfordFitBoost()
        window.sanfordFitBoost.spin()
      })
    }
  }

  if (step === 1) {
    return <Intro onNavigateNext={navigateNext} />
  }

  return (
    <div className='app timer-active'>
      <div className='view'>

        {cols.map(col => (
          <div className='column' key={col.id}>

            <h1 className={`column__title text-${col.color}`}>{col.title}</h1>

            <div id={`slot${col.id}`} className={`slot slot--${col.type}`}>

              {col.cards.map((card, cardIndex) => (
                <div
                  className={`card card--${col.type}`}
                  data-type={col.type}
                  key={cardIndex}
                >
                  <img
                    className='card__img'
                    src={`svg/${col.type}-${card.image}-02.svg`}
                    alt={`${card.name} card`}
                  />
                  <div className='card__body'>
                    <h1>{card.name}</h1>
                    <h4>{card.time}</h4>
                    <div className='timer'>
                      <span className='timer__ready'>Ready...</span>
                      <span className='timer__set'>Set...</span>
                      <span className='timer__go'>Go!</span>
                      <br />
                      <span className='timer__time' />
                    </div>
                    <p>{card.steps.join(' ')}</p>
                    {!!card.desc && (
                      <p className='desc'>*{card.desc}</p>
                    )}
                  </div>
                </div>
              ))}

            </div>

          </div>
        ))}

        <button className='v1-btn' type='button'>Let's Go!</button>

        <div className='modal'>
          <button className='close' type='button'>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 500'>
              <path d='M466.7 500c-8.5 0-17.1-3.3-23.6-9.8L250 297.1 56.9 490.2c-13 13-34.1 13-47.1 0s-13-34.1 0-47.1L202.9 250 9.8 56.9c-13-13-13-34.1 0-47.1s34.1-13 47.1 0L250 202.9 443.1 9.8c13-13 34.1-13 47.1 0s13 34.1 0 47.1L297.1 250l193.1 193.1c13 13 13 34.1 0 47.1-6.5 6.5-15 9.8-23.5 9.8z' />
            </svg>
          </button>
          <button className='next' type='button'>
            <span>Move</span>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 288.3 500'>
              <path d='M22.5 500c-6 0-12-2.4-16.4-7.1-8.5-9.1-8-23.3 1.1-31.8L232.9 250 7.1 38.9C-2 30.4-2.5 16.2 6 7.1 14.5-2 28.7-2.5 37.8 6l243.3 227.5c4.6 4.3 7.1 10.2 7.1 16.4s-2.6 12.2-7.1 16.4L37.9 493.9C33.5 498 28 500 22.5 500z' />
            </svg>
          </button>
        </div>

        <div className='timer-toggle'>
          <label>Timer</label>
          <input
            className='timer-input js-switchery'
            type='checkbox'
            value='timer'
            defaultChecked
          />
        </div>

      </div>
    </div>
  )
}
